<template>
  <iframe
    ref="widget"
    :srcdoc="getWidgetHtml"
    frameborder="0"
    style="height: calc(100vh - 365px); width: 100%"
  ></iframe>
</template>

<script>
import widgetHtml from "./widget.html";

export default {
  props: {
    apiKey: String,
    widgetConstructor: String,
    apiBaseUrl: String,
    cdnBaseUrl: String,
    widgetSlug: String,
    stateSetter: Function,
  },
  data() {
    return {
      widgetHtml: widgetHtml,
    };
  },
  mounted() {
    let interval = setInterval(() => {
      if (!this.$refs.widget.contentWindow.widget.loading) {
        clearInterval(interval);

        this.stateSetter(this.$refs.widget.contentWindow);

        this.$refs.widget.contentWindow.widget.reload();
      }
    }, 100);
  },
  computed: {
    getWidgetHtml() {
      return this.widgetHtml
        .replace("#API_KEY", this.apiKey)
        .replace("#WIDGET_NAME", this.widgetConstructor)
        .replaceAll("#CDN_BASE_URL", this.cdnBaseUrl)
        .replace("#API_BASE_URL", this.apiBaseUrl)
        .replace("#WIDGET_SLUG", this.widgetSlug);
    },
  },
};
</script>

<style scoped>
/* If you have any component-specific styles, add them here */
</style>
